<!--
 * @Description:市场营销-线索管理
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-04-21 16:44:29
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table
        rowKey="clueId"
        :row-selection="{ onChange: onSelectChange }"
        :columns="columns"
        serial
        @fetch="fetch"
        v-model:search="searchFrom"
        ref="tableRef"
        tableId="DcCosLbuLeadManage"
        @mask="showMask"
      >
        <template #search>
          <a-form :model="searchFrom">
            <dc-form-item label="线索状态">
              <a-radio-group
                v-model:value="searchFrom.clueStatus"
                optionType="button"
                @change="search"
                :options="clueStatus"
              />
            </dc-form-item>
            <dc-form-item label="线索类型">
              <a-select v-model:value="searchFrom.clueType" placeholder="请选择" allowClear :options="clueType" />
            </dc-form-item>
            <dc-form-item label="市场线索ID">
              <a-input v-model:value="searchFrom.clueId" placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="创建时间">
              <cos-range-picker
                v-model:startTime="searchFrom.createStartTime"
                v-model:endTime="searchFrom.createEndTime"
              />
            </dc-form-item>
            <dc-form-item label="来源渠道">
              <a-input-group compact>
                <ParamCodeCascader
                  type="search"
                  v-model:ids="searchFrom.channelList"
                  appId="cos_zbu"
                  paramCode="zbu_source_channel_lbu"
                  style="width: 33%"
                />
                <a-input v-model:value="searchFrom.channelExplain" style="width: 67%" placeholder="请输入" />
              </a-input-group>
            </dc-form-item>
            <dc-form-item label="客户名称">
              <a-input v-model:value="searchFrom.customerName" placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="联系方式">
              <a-input-group compact>
                <a-select
                  v-model:value="searchFrom.contact.type"
                  :options="linkMethods"
                  style="width: 33%"
                  placeholder="请选择"
                />
                <a-input v-model:value="searchFrom.contact.keyword" style="width: 67%" placeholder="请输入" />
              </a-input-group>
            </dc-form-item>
            <dc-form-item label="标签">
              <a-auto-complete
                v-model:value="searchFrom.tag"
                :options="tagList"
                :fieldNames="{ label: 'name', value: 'name' }"
                placeholder="请输入"
                @search="tagSearch"
                @focus="tagFocus"
              />
            </dc-form-item>
            <dc-form-item label="投放时间">
              <cos-range-picker
                v-model:startTime="searchFrom.track.startPushTime"
                v-model:endTime="searchFrom.track.endPushTime"
              />
            </dc-form-item>
            <dc-form-item label="销售线索ID">
              <a-input v-model:value="searchFrom.track.acceptorClueId" placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="客户区域">
              <CustomerAreaCascader
                appId="cos_lbu"
                type="search"
                :multiple="false"
                v-model:ids="searchFrom.track.customerRegionList"
              />
            </dc-form-item>
            <dc-form-item label="当前跟进人">
              <user-select v-model:value="searchFrom.track.follower" />
            </dc-form-item>
            <dc-form-item label="客户阶段">
              <a-select
                v-model:value="searchFrom.track.stage"
                placeholder="请选择"
                allow-clear
                :options="lbuCustomerStageEnum"
              />
            </dc-form-item>
            <dc-form-item label="客户状态">
              <a-select
                v-model:value="searchFrom.track.statusList"
                mode="multiple"
                maxTagCount="responsive"
                placeholder="请选择"
                allow-clear
                :options="statusList"
              />
            </dc-form-item>
            <dc-form-item label="客户代码">
              <a-input v-model:value="searchFrom.track.customerNumber" placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="创建人">
              <user-select v-model:value="searchFrom.createBy" />
            </dc-form-item>
          </a-form>
        </template>
        <template #button>
          <a-button type="primary" @click="handleAdd" v-permission="'lbu_lead_add_btn'"> 新增 </a-button>
          <clue-merge-button :data="selectedRows" @success="success" v-permission="'lbu_lead_merge_btn'"
            >合并</clue-merge-button
          >
          <a-button @click="handleInValid" v-permission="'lbu_lead_invalid_btn'">置为无效</a-button>
          <a-button @click="handleValid" v-permission="'lbu_lead_valid_btn'"> 置为有效 </a-button>
          <a-button @click="handleFuture" v-permission="'lbu_lead_future_btn'"> 置为未来线索 </a-button>
          <PutIn :data="selectedRows" appId="cos_lbu" @success="success" v-permission="'lbu_lead_release_btn'"
            >投放</PutIn
          >
          <CustomPut :data="selectedRows" @success="success" appId="cos_lbu" v-permission="'lbu_lead_release_btn'"
            >批量投放</CustomPut
          >
          <ImportBtn
            action="/zbu/api/clue/import"
            templateUrl="/zbu/api/clue/template/download"
            @success="success('search')"
            v-permission="'lbu_lead_import_btn'"
            >导入</ImportBtn
          >
          <ExportButton appId="cos_zbu" taskType="101" :search="searchFrom" v-permission="'lbu_lead_export_btn'"
            >导出</ExportButton
          >
          <a-button danger v-permission="'lbu_lead_del_btn'" @click="handleDelete()">删除</a-button>
        </template>
        <template #bodyCell="{ column, record, text }">
          <template v-if="column.dataIndex === 'customerTag'">
            <p>{{ text && Array.isArray(text) && text.length ? text.join('、') : '--' }}</p>
          </template>
          <template v-if="column.dataIndex === 'channel'">
            <ChannelText
              appId="cos_zbu"
              paramCode="zbu_source_channel_lbu"
              :value="text"
              :desc="record.channelExplain"
            />
          </template>
          <template v-if="column.dataIndex === 'customerOffice'">
            <CustomerArea type="text" :value="text" />
          </template>
          <template v-if="Array.isArray(column.dataIndex) && column.dataIndex.join('.') === 'track.customerRegion'">
            <CustomerAreaCascaderText appId="cos_lbu" :value="text" />
          </template>
          <!--置为有效： 未投放的无效线索/新线索 -->
          <!--置为无效：未投放的有效线索/新线索 -->
          <template v-if="column.dataIndex === 'action'">
            <MoreButton>
              <a-button
                type="link"
                :disabled="record.clueStatus === 0 ? false : true"
                @click="handleEdit(record)"
                v-permission="'lbu_lead_edit_btn'"
              >
                编辑
              </a-button>
              <a-button
                type="link"
                @click="handleValid(record)"
                v-show="record.clueStatus === 0 && record.clueType !== 2"
                v-permission="'lbu_lead_valid_btn'"
              >
                置为有效
              </a-button>
              <a-button
                type="link"
                v-show="record.clueStatus === 0 && record.clueType !== 3"
                @click="handleInValid(record)"
                v-permission="'lbu_lead_invalid_btn'"
              >
                置为无效
              </a-button>
              <a-button
                type="link"
                v-show="record.clueStatus === 0 && record.clueType !== 1"
                @click="handleFuture(record)"
                v-permission="'lbu_lead_future_btn'"
              >
                置为未来线索
              </a-button>
              <a-button type="link" @click="handleRelevance(record)" v-permission="'lbu_lead_relevance_btn'">
                关联线索
              </a-button>
              <a-button type="link" @click="handleDelete(record)" v-permission="'lbu_lead_del_btn'"> 删除 </a-button>
            </MoreButton>
          </template>
        </template>
      </cos-table>
      <!--置为无效-->
      <InvalidModel ref="invalidModelRef" @success="success" />
      <!--关联线索-->
      <RelevanceClue ref="relevanceClue" @success="success" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script setup lang="ts">
import { onMounted, reactive, ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import {
  clueGet,
  clueDelete,
  clueToValid,
  clueToFuture,
  clueDetail,
  parentLabelList
} from '@/api/marketing/marketingManage'
import { listByParamCodes } from '@/api/common'
import type { ClueManage, ClueManageParams } from '@/typings/api/marketingManage'
import { DcMessage } from '@dc-platform/dc-components'
import Modal from '@/hooks/modalType'
import { DropListType } from '@/typings/common'
import ClueMergeButton from '@/components/ClueMergeButton'
import ImportBtn from '@/components/ImportBtn'
import CustomerArea from '@/components/CustomerArea'
import ChannelText from '@/components/CosCascaderText/components/channel.vue'
import InvalidModel from '@/views/yuntuSales/marketLeads/components/invalidModel.vue'
import RelevanceClue from '@/components/MarketLeads/RelevanceClue/index.vue'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import { cloneDeep } from 'lodash-es'
import PutIn from '@/components/MarketLeads/PutIn/index.vue'
import CustomPut from '@/components/MarketLeads/CustomPut/index.vue'
import {
  clueStatus,
  clueType,
  linkMethods,
  lbuCustomerAllStatusEnum,
  lbuCustomerStageEnum
} from '@/views/marketing/commonEnum/dataConfig'
const router = useRouter()
const invalidModelRef = ref()
const relevanceClue = ref()
const tableRef = ref()
const searchFrom = ref<ClueManageParams>({
  contact: {
    type: 1
  },
  track: {},
  business: {}
})
const alltagList = ref<DropListType>([])
const tagList = ref<DropListType>([])
const selectedRows = ref<any[]>([])
const paramCodeData = reactive<{
  zbu_product_type_lbu: []
  zbu_channel_detail_lbu: []
  zbu_demand_info_lbu: []
  zbu_monthly_sales_lbu: []
  zbu_service_demand_lbu: []
  zbu_existing_cooperation_lbu: []
  zbu_customer_area_lbu: []
  zbu_sales_category_lbu: []
}>({
  zbu_product_type_lbu: [], // 产品货型
  zbu_channel_detail_lbu: [], // 销售平台
  zbu_demand_info_lbu: [], // 需求海外仓
  zbu_monthly_sales_lbu: [], // 跨境月销售额
  zbu_service_demand_lbu: [], // 服务需求
  zbu_existing_cooperation_lbu: [], // 是否已有合作
  zbu_customer_area_lbu: [], // 客户区域
  zbu_sales_category_lbu: [] // 销售品类
})
const statusList = computed(() => {
  const stage = searchFrom.value.track?.stage
  const filterState = [1, 8, 2]
  if (stage) {
    // 待领取，已转换，待跟进 不显示 1，8，2
    const min = (stage - 1) * 10 - 1
    const max = stage * 10 - 1
    const result = lbuCustomerAllStatusEnum.filter(
      (item: any) => item.value > min && item.value < max && !filterState.includes(item.value)
    )
    // searchFrom.value.statusList = []
    return result
  } else {
    return lbuCustomerAllStatusEnum.filter((item: any) => !filterState.includes(item.value))
  }
})
// 列表
const fetch = (params: object, callBack: (res: any) => void) => {
  clueGet(params).then((res) => {
    callBack(res)
  })
}
const showMask = (row: ClueManage, callBack: (res: any) => void) => {
  clueDetail({
    clueId: row.clueId
  }).then((res) => {
    callBack(res.data.contact)
  })
}
// 获取标签下拉框
const getTag = () => {
  parentLabelList().then((res) => {
    tagList.value = res.data
    alltagList.value = res.data
  })
}
onMounted(() => {
  getByParamCodes()
  getTag()
})
// 标签筛选
const tagSearch = (searchText: string) => {
  const list = alltagList.value.filter((v: any) => v.name?.toLowerCase().indexOf(searchText.toLowerCase()) >= 0)
  tagList.value = !searchText ? cloneDeep(alltagList.value) : cloneDeep(list)
}
const tagFocus = () => {
  if (!searchFrom.value.tag) {
    tagSearch('')
  }
}
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_zbu',
    paramCodes: [
      'zbu_product_type_lbu',
      'zbu_channel_detail_lbu',
      'zbu_demand_info_lbu',
      'zbu_monthly_sales_lbu',
      'zbu_service_demand_lbu',
      'zbu_existing_cooperation_lbu',
      'zbu_sales_category_lbu'
    ]
  }).then((res) => {
    if (res.code === 200) {
      Object.assign(paramCodeData, res.data)
    }
  })
}
const success = (type?: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value.search()
  } else {
    tableRef.value.fetch()
  }
}
const search = () => {
  tableRef.value.search()
}
// 新增
const handleAdd = () => {
  router.push({
    path: '/lbu/leadManage/add'
  })
}
// 编辑
const handleEdit = (row: ClueManage) => {
  router.push({
    path: '/lbu/leadManage/edit',
    query: {
      clueId: row.clueId
    }
  })
}
// 置为无效
const handleInValid = (row?: ClueManage) => {
  let result = []
  if (row && row.clueId) {
    result.push(row)
  } else {
    result = selectedRows.value
  }
  invalidModelRef.value.toggle(result)
}
// 置为有效
const handleValid = (row?: ClueManageParams) => {
  let ids: any[] = []
  if (row && row.clueId) {
    ids.push(row.clueId)
  } else {
    ids = selectedRows.value.map((item) => item.clueId)
  }
  // 未投放的无效和新线索
  if (!ids || ids.length < 1) {
    DcMessage.error('请选择数据！')
    return
  }
  Modal.switch({
    title: '确定置为有效线索？',
    onOk() {
      clueToValid({ clueIdList: ids }).then(() => {
        DcMessage.success('置为有效成功')
        success()
      })
    }
  })
}
// 置为未来线索
const handleFuture = (row?: ClueManageParams) => {
  let ids: any[] = []
  if (row && row.clueId) {
    ids.push(row.clueId)
  } else {
    ids = selectedRows.value.map((item) => item.clueId)
  }
  // 未投放的无效和新线索
  if (!ids || ids.length < 1) {
    DcMessage.error('请选择数据！')
    return
  }
  Modal.switch({
    title: '确定置为未来线索？',
    onOk() {
      clueToFuture({ clueIdList: ids }).then(() => {
        DcMessage.success('置为未来线索成功')
        success()
      })
    }
  })
}
// 删除
const handleDelete = (row?: ClueManage) => {
  if (!row && !selectedRows.value?.length) {
    return DcMessage.error('请选择要删除的数据')
  }
  // 过滤出有效线索、新线索
  let name: any = []
  let clueIdList: any = []
  if (row && row.clueId) {
    name = [row.customerName]
    clueIdList = [row.clueId]
  } else {
    selectedRows.value?.forEach((item) => {
      clueIdList.push(item.clueId)
      name.push(item.customerName)
    })
  }
  Modal.delete({
    name: name.join('，'),
    onOk() {
      clueDelete({
        clueIdList
      }).then(() => {
        tableRef.value.delFetch()
        DcMessage.success('删除成功')
      })
    }
  })
}
// 关联线索
const handleRelevance = (row?: ClueManage) => {
  relevanceClue.value.showModal(row)
}
const onSelectChange = (selectedRowKeys: string[], rows: ClueManage[]) => {
  selectedRows.value = rows
}

const columns = computed(() => [
  {
    title: '客户名称',
    dataIndex: 'customerName',
    cosType: 'link',
    path: '/lbu/leadManage/view',
    query: ['clueId', 'track.acceptorClueId'],
    fixed: 'left',
    width: 200
  },
  {
    title: '来源渠道',
    dataIndex: 'channel',
    width: 200
  },
  {
    title: '客户办公地',
    dataIndex: 'customerOffice'
  },
  {
    title: '标签',
    dataIndex: 'customerTag'
  },
  {
    title: '联系人名称',
    dataIndex: ['contact', 'name'],
    cosType: 'mask'
  },
  {
    title: '手机号',
    dataIndex: ['contact', 'mobile'],
    cosType: 'mask'
  },
  {
    title: '邮箱',
    dataIndex: ['contact', 'email'],
    cosType: 'mask'
  },
  {
    title: '微信号',
    dataIndex: ['contact', 'wechat'],
    cosType: 'mask'
  },
  {
    title: 'QQ号',
    dataIndex: ['contact', 'qq'],
    cosType: 'mask'
  },
  {
    title: '固定电话',
    dataIndex: ['contact', 'tel'],
    cosType: 'mask'
  },
  {
    title: '产品货型',
    dataIndex: ['business', 'cargoType'],
    dicData: paramCodeData.zbu_product_type_lbu
  },
  {
    title: '销售平台',
    dataIndex: ['business', 'salePlatform'],
    dicData: paramCodeData.zbu_channel_detail_lbu
  },
  {
    title: '需求海外仓',
    dataIndex: ['business', 'warehouse'],
    dicData: paramCodeData.zbu_demand_info_lbu
  },
  {
    title: '目的国家',
    dataIndex: ['business', 'destinationCountry']
  },
  {
    title: '发货地',
    dataIndex: ['business', 'shipAddress']
  },
  {
    title: '销售品类',
    dataIndex: ['business', 'salesCategory'],
    dicData: paramCodeData.zbu_sales_category_lbu
  },
  {
    title: '跨境月销售额',
    dataIndex: ['business', 'monthSales'],
    dicData: paramCodeData.zbu_monthly_sales_lbu
  },

  {
    title: '服务需求',
    dataIndex: ['business', 'serviceNeeds'],
    dicData: paramCodeData.zbu_service_demand_lbu
  },
  {
    title: '线索类型',
    dataIndex: 'clueType',
    dicData: clueType
  },
  {
    title: '线索状态',
    dataIndex: 'clueStatus',
    dicData: clueStatus
  },
  {
    title: '创建人',
    dataIndex: 'createByName'
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    width: 190
  },
  {
    title: '当前跟进人',
    dataIndex: ['track', 'followerName']
  },
  {
    title: '客户区域',
    dataIndex: ['track', 'customerRegion']
  },
  {
    title: '客户阶段',
    dataIndex: ['track', 'stage'],
    dicData: lbuCustomerStageEnum,
    width: 190
  },
  {
    title: '客户状态',
    dataIndex: ['track', 'status'],
    dicData: lbuCustomerAllStatusEnum,
    width: 190
  },
  {
    title: '客户代码',
    dataIndex: ['track', 'customerNumber'],
    width: 190
  },
  {
    title: '领取时间',
    dataIndex: ['track', 'salesCollectionTime'],
    width: 190
  },
  {
    title: '转潜在时间',
    dataIndex: ['track', 'turnPotentialTime'],
    width: 190
  },
  {
    title: '成交时间',
    dataIndex: ['track', 'turnCustomerTime'],
    width: 190
  },
  {
    title: '成交额',
    dataIndex: ['track', 'clinchAmount']
  },
  {
    title: '无效时间',
    dataIndex: ['track', 'invalidTime'],
    width: 190
  },
  {
    title: '无效原因',
    dataIndex: ['track', 'invalidReason']
  },
  {
    title: '市场线索ID',
    dataIndex: 'clueId'
  },
  {
    title: '销售线索ID',
    dataIndex: ['track', 'acceptorClueId']
  },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right',
    width: 220
  }
])
</script>
<script lang="ts">
export default { name: 'DcCosLbuLeadManage' }
</script>
